import React from 'react';
import JsonData from "../JsonData/jsonData.json";

const Faq2 = () => {

  return (
    <>
      {JsonData.faq.map((faq, index) => {
        return (
          <div className="space-y-2">
            <h2 className="text-2xl font-bold mb-4">{index + 5 + "."} {faq.title}</h2>
            <p className="pl-6">{faq.description}</p>
          </div>
        );
      })}
    </>
  );
};

export default Faq2;